
// export default FinancialCharts

import React, { useEffect, useRef, useState } from "react";
import Sidebar from "./Sidebar";

import axios from "axios";

const FinancialCharts = () => {
  const chartContainerRef = useRef(null);
  const canvasRef = useRef(null);
  const [selectedTool, setSelectedTool] = useState(null);
  const [lines, setLines] = useState([]);
  const linesRef = useRef([]);

const startRef = useRef(null)
const chartRef = useRef(null);
const seriesRef = useRef(null);
const [selectedLineId, setSelectedLineId] = useState(null);
const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });



// Track lines in ref for render loop
  useEffect(() => {
    linesRef.current = lines;
  }, [lines]);

  useEffect(() => {
    if (!window.LightweightCharts) {
      console.error("LightweightCharts not loaded from CDN!");
      return;
    }

    // const chart = window.LightweightCharts.createChart(chartContainerRef.current, {
    //   width: chartContainerRef.current.clientWidth,
    //   height: 500,
    //   layout: {
    //     backgroundColor: "#ffffff",
    //     textColor: "#000",
    //   },
    //   grid: {
    //     vertLines: { color: "#e1e1e1" },
    //     horzLines: { color: "#e1e1e1" },
    //   },
    //   crosshair: { mode: 1 },
    // });




 // 1. Initialize Chart
        const chart = window.LightweightCharts.createChart(chartContainerRef.current, {
            width: chartContainerRef.current.clientWidth,
            height: 500,
            layout: { 
                textColor: '#334155', // slate-700
                background: { type: 'solid', color: '#ffffff' } 
            },
            grid: { 
                vertLines: { color: '#f1f5f9' }, // slate-100
                horzLines: { color: '#f1f5f9' } 
            },
            timeScale: {
                borderColor: '#e2e8f0', // slate-200
            },
        });



//     const candleSeries = chart.addCandlestickSeries({
//       upColor: "#26a69a",
//       downColor: "#ef5350",
//       borderVisible: false,
//       wickUpColor: "#26a69a",
//       wickDownColor: "#ef5350",
//     });

//    candleSeries.setData([
//   { time: "2025-10-20", open: 100, high: 110, low: 90, close: 105 }, // green
//   { time: "2025-10-21", open: 105, high: 112, low: 101, close: 108 }, // green
//   { time: "2025-10-22", open: 108, high: 115, low: 105, close: 107 }, // 🔴 red (close < open)
//   { time: "2025-10-23", open: 107, high: 110, low: 102, close: 104 }, // 🔴 red
//   { time: "2025-10-24", open: 104, high: 112, low: 103, close: 110 }, // 🟩 green
//   { time: "2025-10-25", open: 110, high: 115, low: 108, close: 112 }, // 🟩 green
//   { time: "2025-10-26", open: 112, high: 118, low: 111, close: 113 }, // 🟩 green
//   { time: "2025-10-27", open: 113, high: 117, low: 109, close: 110 }, // 🔴 red

  
// ]);


  const candleSeries = chart.addCandlestickSeries({
            upColor: '#10B981',     // emerald-500
            downColor: '#EF4444',   // red-500
            borderVisible: false,
            wickUpColor: '#10B981',
            wickDownColor: '#EF4444',
        });

       const data = [];
        let price = 100;
        const date = new Date(2023, 0, 1);
        for(let i=0; i<150; i++) {
            date.setDate(date.getDate() + 1);
            const open = price;
            const close = open + (Math.random() * 10 - 5);
            const high = Math.max(open, close) + Math.random() * 2;
            const low = Math.min(open, close) - Math.random() * 2;
            price = close;
            data.push({ 
                time: date.toISOString().split('T')[0], 
                open, high, low, close 
            });
        }
        candleSeries.setData(data);


   chartRef.current = chart;
  seriesRef.current = candleSeries;

  // ✅ DRAWING LOGIC HERE
  const canvas = canvasRef.current;
  const ctx = canvas.getContext("2d");

  const x1 = chart.timeScale().timeToCoordinate("2025-10-24");
  const y1 = candleSeries.priceToCoordinate(110);
  const x2 = chart.timeScale().timeToCoordinate("2025-10-27");
  const y2 = candleSeries.priceToCoordinate(113);

  if (x1 !== null && y1 !== null && x2 !== null && y2 !== null) {
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.strokeStyle = "#2962FF";
    ctx.lineWidth = 2;
    ctx.stroke();
  }

    const handleResize = () => {
      chart.applyOptions({ width: chartContainerRef.current.clientWidth });
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      chart.remove();
    };
  
  }, []);

  // Responsive canvas
  
  useEffect(() => {
    const canvas = canvasRef.current;
    const container = chartContainerRef.current;

    const resizeCanvas = () => {
      canvas.width = container.clientWidth;
      canvas.height = container.clientHeight;
    };

    resizeCanvas();
    window.addEventListener("resize", resizeCanvas);
    return () => window.removeEventListener("resize", resizeCanvas);
  }, []);


  
useEffect(() => {
  const canvas = canvasRef.current;
  const ctx = canvas.getContext("2d");
  let isDrawing = false;
  let startX, startY;

  const resizeCanvas = () => {
    if (!canvas || !chartContainerRef.current) return;
    canvas.width = chartContainerRef.current.clientWidth;
    canvas.height = chartContainerRef.current.clientHeight;
  };
  resizeCanvas();
  window.addEventListener("resize", resizeCanvas);

  const drawAllLines = () => {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.lineWidth = 2;
    ctx.strokeStyle = "#2962FF";

    linesRef.current.forEach((line) => {
      ctx.beginPath();
      ctx.moveTo(line.x1, line.y1);
      ctx.lineTo(line.x2, line.y2);
      ctx.stroke();

      ctx.beginPath();
      ctx.arc(line.x1, line.y1, 5, 0, 2 * Math.PI);
      ctx.arc(line.x2, line.y2, 5, 0, 2 * Math.PI);
      ctx.stroke();
    });
  };

  const render = () => {
    drawAllLines();
    requestAnimationFrame(render);
  };
  render();

  const handleMouseDown = (e) => {
    if (selectedTool !== "trendline") return;
    isDrawing = true;
    const rect = canvas.getBoundingClientRect();
    startX = e.clientX - rect.left;
    startY = e.clientY - rect.top;
  };

  const handleMouseUp = (e) => {
    if (!isDrawing) return;
    isDrawing = false;
    const rect = canvas.getBoundingClientRect();
    const endX = e.clientX - rect.left;
    const endY = e.clientY - rect.top;

    setLines((prev) => [
      ...prev,
      { id: Date.now(), x1: startX, y1: startY, x2: endX, y2: endY },
    ]);
  };

  const handleClick = (e) => {
    const rect = canvas.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const clickY = e.clientY - rect.top;
    const threshold = 5;

    const clickedLine = linesRef.current.find((line) => {
      const { x1, y1, x2, y2 } = line;
      const dx = x2 - x1;
      const dy = y2 - y1;
      const lengthSq = dx * dx + dy * dy;
      const t = ((clickX - x1) * dx + (clickY - y1) * dy) / lengthSq;
      if (t < 0 || t > 1) return false;

      const closestX = x1 + t * dx;
      const closestY = y1 + t * dy;
      const dist = Math.hypot(clickX - closestX, clickY - closestY);
      return dist < threshold;
    });

    if (clickedLine) {
      setSelectedLineId(clickedLine.id);
      setPopupPosition({ x: e.clientX, y: e.clientY });
    } else {
      setSelectedLineId(null);
    }
  };

  // ✅ Attach all handlers here
  canvas.addEventListener("mousedown", handleMouseDown);
  canvas.addEventListener("mouseup", handleMouseUp);
  canvas.addEventListener("click", handleClick);

  return () => {
    window.removeEventListener("resize", resizeCanvas);
    canvas.removeEventListener("mousedown", handleMouseDown);
    canvas.removeEventListener("mouseup", handleMouseUp);
    canvas.removeEventListener("click", handleClick); // ✅ remove properly
  };
}, [selectedTool]);

 


const [loading,setLoading] = useState(false)

const [signals, setSignals] = useState([])

const[error,setError] = useState("")

const [isOpen, setIsOpen] = useState(false);



const getSignals = async () => {
  setLoading(true);
  setError(null);
  setIsOpen(true);

  try {
    const response = await axios.get("http://127.0.0.1:8000/get_signals");
    const data = response.data;

    if (!data.signals || !Array.isArray(data.signals)) {
      throw new Error("Invalid response format");
    }

    // Flatten nested batches
    const flatSignals = Array.isArray(data.signals[0]) ? data.signals.flat() : data.signals;
    console.log("flatsignals", flatSignals)
    setSignals(flatSignals);

  } catch (err) {
    setError(err.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};


  const closeModal = () => {
    setIsOpen(false);
  };

const runSignals = async () => {
  setLoading(true);
  setError(null);

  try {
    const response = await axios.post("http://127.0.0.1:8000/run_signals");

    if (!response || !response.data) {
      throw new Error("Empty response from server");
    }

    const data = response.data;

    // Since backend runs job in background, there is no signals array yet
    if (data.signals && Array.isArray(data.signals)) {
      // If signals are returned immediately (optional)
      console.log("Signals fetched:", data.signals);
      return data.signals;
    } else {
      // Job is running in background
      console.log("Job started:", data.message || data.status);
      return null;
    }

  } catch (err) {
    console.error("Error running signals:", err);
    setError(err.message || "Something went wrong");
    return null;
  } finally {
    setLoading(false);
  }
};






  return (
    <div className="flex h-screen ">
      {/* Sidebar */}
      <aside className="w-16 bg-gray-900 text-white flex flex-col items-center py-4 space-y-6">
        {/* <button className="hover:bg-gray-700 p-2 rounded">📈</button> */}
        {/* <button className="hover:bg-gray-700 p-2 rounded">✏️</button>
        <button className="hover:bg-gray-700 p-2 rounded">📊</button>
        <button className="hover:bg-gray-700 p-2 rounded">⚙️</button>
      </aside> */}

    <Sidebar onSelectTool={setSelectedTool} />
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        {/* Topbar */}
        <header className="bg-gray-800 text-white p-3 flex justify-between items-center">
          <div className="flex items-center space-x-4">
            <h2 className="text-lg font-bold">BTC/USD</h2>
            {/* <button className="bg-gray-700 px-3 py-1 rounded hover:bg-gray-600">1D</button>
            <button className="bg-gray-700 px-3 py-1 rounded hover:bg-gray-600">1W</button>
            <button className="bg-gray-700 px-3 py-1 rounded hover:bg-gray-600">1M</button> */}

            <input className="text-black rounded-md px-3 py-1" placeholder="Symbol"></input>
            {/* <select className=" text-black px-3 py-1 rounded-sm z-50 ">
                <option>1 D</option>
                <option>1 W</option>
                 <option>1 M</option>
            </select> */}
            <div className="relative z-[9999]">
  <select className=" bg-white text-black px-3 py-1 rounded shadow-md border border-gray-300 z-[9999]">
    <option>1 D</option>
    <option>1 W</option>
    <option>1 M</option>
  </select>
</div>

          </div>
          <div className="flex items-center space-x-3 ">
            <button className="bg-green-600 px-3 py-1 rounded">Buy</button>
            <button className="bg-red-600 px-3 py-1 rounded">Sell</button>
              <button onClick={runSignals} className=" bg-blue-400 px-4 py-1 rounded">Submit</button>
                <button onClick={getSignals} className=" bg-blue-500 px-4 py-1 rounded">Get Signals</button>

                {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-3xl max-h-[80vh] overflow-y-auto relative">
            <button
              onClick={closeModal}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 font-bold text-lg"
            >
              &times;
            </button>

            <div className="p-6">
              <h2 className="text-2xl font-semibold mb-4">Signals ({signals.length})</h2>

              {loading && <p className="text-gray-500">Loading...</p>}
              {error && <p className="text-red-500">{error}</p>}

              {!loading && !error && signals.length > 0 && (

                <>
                console.log("Rendering signals:", signals)
              
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {signals.map((signal, index) => (
                    <div
                      key={index}
                      className="border text-black border-gray-200 rounded p-4 shadow-sm hover:shadow-md transition"
                    >
                      <p>
                        <span className="font-semibold">Symbol:</span> {signal.trading_symbol}
                      </p>
                      <p>
                        <span className="font-semibold">Exchange:</span> {signal.exchange}
                      </p>
                      {signal.rsi !== undefined && (
                        <p>
                          <span className="font-semibold">RSI:</span> {signal.rsi.toFixed(2)}
                        </p>
                      )}
                      {signal.type && (
                        <p>
                          <span className="font-semibold">Type:</span> {signal.type}
                        </p>
                      )}
                      {signal.direction && (
                        <p>
                          <span className="font-semibold">Direction:</span> {signal.direction}
                        </p>
                      )}
                      {signal.change_pct !== undefined && (
                        <p>
                          <span className="font-semibold">Change %:</span> {signal.change_pct}
                        </p>
                      )}
                      {signal.ltp !== undefined && (
                        <p>
                          <span className="font-semibold">LTP:</span> {signal.ltp}
                        </p>
                      )}
                      <p>
                        <span className="font-semibold">Time:</span>{" "}
                        {new Date(signal.ts).toLocaleString()}
                      </p>
                    </div>
                  ))}
                </div>
                   </>
              )}

              {!loading && !error && signals.length === 0 && (
                <p className="text-gray-500">No signals available</p>
              )}
            </div>
          </div>
        </div>
      )}
          
          </div>
          
          
         
            
          
        </header>

        
 <div className="flex h-screen relative">
  {/* Chart + Canvas */}
  <div className="flex-1 relative shadow-lg rounded-2xl  m-10 ">
    <div  ref={chartContainerRef} className="absolute inset-0 z-0 rounded-2xl shadow-md"></div>
    <canvas
      ref={canvasRef}
      className="absolute inset-0"
      style={{
        zIndex: 10,
        pointerEvents: selectedTool === "trendline" ? "auto" : "none",
        cursor: selectedTool === "trendline" ? "crosshair" : "default",
         borderRadius: "20px",   
      

      }}
    />
  </div>

  {/* Popup */}
  {selectedLineId && (
    <div
      className="absolute transition-opacity duration-300 ease-in-out bg-white border border-gray-300 rounded shadow-lg p-2 z-50"
      style={{
        top: popupPosition.y,
        left: popupPosition.x,
      }}
    >
      <div className="flex space-x-2">
        <button
          className="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600"
          onClick={() => {
            setLines((prev) => prev.filter((line) => line.id !== selectedLineId));
            setSelectedLineId(null);
          }}
        >
          Delete
        </button>
        <button
          className="bg-gray-300 text-black px-2 py-1 rounded hover:bg-gray-400"
          onClick={() => setSelectedLineId(null)}
        >
          Cancel
        </button>
      </div>
    </div>
  )}
</div>

      </div>
    </div>
  );
};

export default FinancialCharts;
